import builder from '../builder';
import SocialMediaFacebook from '../../streamline-icons/bold/social-media-facebook.svg';

export default builder('IconSocialMediaFacebookBold', SocialMediaFacebook);
